import React, {Component} from "react";
import FlexView from "react-flexview";
import SimpleDDL from "../../../../../../modules/SimpleDDL";
import SimpleDataTable from "../../../../../../modules/SimpleDataTable";
import SimpleInput from "../../../../../../modules/SimpleInput";
import Button from "../../../../../../modules/commons/Button";
import {Scanner} from "@yudiel/react-qr-scanner";
import SimpleModal from "../../../../../../modules/popup/SimpleModal";
import Api from "../../../../../../Services/Api";
import * as R from "ramda";
import {ACTIVITY_TYPE} from "../../../../../common/Constants";
import SimpleButton from "../../../../../../modules/commons/SimpleButton";
import { defaultTableChange } from "../../../../../../modules/custom/customTable";

class MutasiDetailQrTab extends Component {
    constructor(props) {
        super(props);
        this.tabHadiah = props.tab === "hadiah";
        this.kodeKey = this.tabHadiah ? "kodeHadiah" : "kodeOtherItem";
        this.dtoKey = this.tabHadiah ? "masterGiftDTO" : "masterOtherItemDTO";
        this.categoryKey = this.tabHadiah ? "categoryHadiah" : "categoryOtherItem";
        this.nameKey = this.tabHadiah ? "namaHadiah" : "nameOtherItem";
        this.dataName = this.tabHadiah ? "mutationGiftBarcodes" : "mutationOtherBarcodes";
        this.name = this.tabHadiah ? "masterGiftDTO.namaHadiah" : "masterOtherItemDTO.nameOtherItem";
        this.tableColumns = [
            {
                name: "",
                label: "No",
                options: {
                    customBodyRender: (_, {rowIndex}) =>
                        <p className={this.props.state.data[this.dataName][rowIndex].status === "REJECTED" ? "color-red" : "color-black"}>
                            {rowIndex + 1}
                        </p>,
                    setCellProps: () => ({
                        style: {width: "5%"},
                    }),
                },
            },
            {
                name: this.kodeKey,
                options: {
                    customHeadRender: (props) => (
                        <th key={props.index} className="custom-locator padding-right-15px">
                            <p style={{display: "flex"}}>
                                {this.props.mutasiKeluarTab ? (
                                    <>
                                        {this.tabHadiah ? "Kode Hadiah" : "Kode Barang"}
                                        <span style={{color: "red"}}>*</span>
                                    </>
                                ) : (
                                    <>{this.tabHadiah ? "Kode Hadiah" : "Kode Barang"}</>
                                )}
                            </p>
                        </th>
                    ),
                    customBodyRender: (val, {rowIndex}) => (
                        <>
                            {this.props.mutasiKeluarTab ? (
                                <SimpleDDL
                                    id="select_options_kode_varian"
                                    name={this.kodeKey}
                                    box="search"
                                    styles={{
                                        menu: (provided) => ({
                                            ...provided,
                                            position: "relative",
                                            fontFamily: "FontFirst2, Helvetica Neue, Helvetica, Arial, sans-serif",
                                        }),
                                    }}
                                    containerclassname="margin-bottom-none"
                                    readOnly={this.props.state.data[this.dataName][rowIndex].saved}
                                    options={
                                        this.tabHadiah
                                            ? this.props.state.kodeHadiahOptions.filter(item => item.qrHadiah === true)
                                            : this.props.state.kodeBarangLainOptions.filter(item => item.qrotheritem === true)
                                    }
                                    value={val}
                                    onChange={(value, {name}) => {
                                        this.props.onSetState((prevValue) => ({
                                            ...prevValue,
                                            data: {
                                                ...prevValue.data,
                                                [this.dataName]: prevValue.data[this.dataName].map((d, idx) =>
                                                    idx === rowIndex
                                                        ? {
                                                            ...d,
                                                            [name]: value,
                                                            [this.dtoKey]: {
                                                                [this.categoryKey]: value.category,
                                                                [this.nameKey]: value.name,
                                                            },
                                                            satuan: value.satuan,
                                                        }
                                                        : d
                                                ),
                                            },
                                        }));
                                    }}
                                />
                            ) : (
                                <p className={this.props.state.data[this.dataName][rowIndex].status === "REJECTED" ? "color-red" : "color-black"}>
                                    {val.label}
                                </p>
                            )}
                        </>
                    ),
                    setCellProps: () => ({
                        style: {width: "100px"},
                    }),
                },
            },
            {
                name: this.name,
                label: this.tabHadiah ? "Nama Hadiah" : "Nama Barang Lain",
                options:
                    {
                        customBodyRender: (val, {rowIndex}) => (
                            <p className={this.props.state.data[this.dataName][rowIndex].status === "REJECTED" ? "color-red" : "color-black"}>
                                {val}
                            </p>
                        ),
                        setCellProps:
                            () => ({
                                style: {width: "200px"},
                            }),
                    }
            },
            {
                name: this.tabHadiah
                    ? "masterGiftDTO.categoryHadiah"
                    : "masterOtherItemDTO.categoryOtherItem",
                label: "Kategori",
                options:
                    {
                        customBodyRender: (val, {rowIndex}) => (
                            <p className={this.props.state.data[this.dataName][rowIndex].status === "REJECTED" ? "color-red" : "color-black"}>
                                {val}
                            </p>
                        )
                    }
            },
            {
                name: "qty",
                label: "Qty",
                options:
                    {
                        customBodyRender: (val, {rowIndex}) => (
                            <p className={this.props.state.data[this.dataName][rowIndex].status === "REJECTED" ? "color-red" : "color-black"}>
                                {val}
                            </p>
                        )
                    }
            },
            {
                name: "satuan",
                label: "Satuan",
                options:
                    {
                        customBodyRender: (val, {rowIndex}) => (
                            <p className={this.props.state.data[this.dataName][rowIndex].status === "REJECTED" ? "color-red" : "color-black"}>
                                {val}
                            </p>
                        )
                    }
            },
            {
                name: "otherBarcode",
                options: {
                    customHeadRender: (props) => (
                        <th key={props.index} className="custom-locator padding-right-15px">
                            <p style={{display: "flex"}}>
                                {this.props.mutasiKeluarTab ? (
                                    <>
                                        QR Code<span style={{color: "red"}}>*</span>
                                    </>
                                ) : (
                                    "QR Code"
                                )}
                            </p>
                        </th>
                    ),
                    customBodyRender: (val, {rowIndex}) => (
                        <SimpleInput
                            id="input_text_qrcode"
                            name="otherBarcode"
                            readOnly={this.props.state.data[this.dataName][rowIndex].saved}
                            value={val}
                            containerclassname="margin-bottom-none"
                            onChange={({target}) =>
                                this.props.onSetState((prevValue) => ({
                                    ...prevValue,
                                    data: {
                                        ...prevValue.data,
                                        [this.dataName]: prevValue.data[this.dataName].map((d, idx) =>
                                            idx === rowIndex ? {...d, otherBarcode: target.value} : d
                                        ),
                                    },
                                }))
                            }
                        />
                    ),
                    setCellProps: () => ({
                        style: {width: "250px"},
                    }),
                },
            },
        ];

        this.tableColumns.push({
            name: `${this.props.mutasiKeluarTab ? "saved" : "status"}`,
            label: "Aksi",
            options: {
                customBodyRender: (val, {rowIndex}) => {return this.addDetailButton(val, rowIndex)},
                setCellProps: () => ({
                    style: {width: "5%"},
                }),
            },
        });

        this.state = {
            scannerVisible: false,
            noBarcodeDetected: false,
            pagination: {
                page: 1,
                limit: 5,
                totalData: 0,
            },
        };
    }

    handleChecked = (index) => {
        this.props.onSetState((prevValue) => ({
            ...prevValue,
            data: {
                ...prevValue.data,
                [this.dataName]: prevValue.data[this.dataName].map((d, idx) => (
                        idx === index ? {
                            ...d,
                            status: "RECEIVED",
                            checked: !d.checked
                        } : d
                    )
                ),
            },
        }));
    };

    handleReject = (index) => {
        let obj = this.props.state.data[this.dataName].filter((a, idx) => {
            if (idx === index) a.status = a.status !== "REJECTED" ? "REJECTED" : a.scanned ? "RECEIVED" : "ONPROGRESS";
            return a;
        });
        this.props.onSetState((prevValue) => ({
            ...prevValue,
            data: {
                ...prevValue.data,
                [this.dataName]: obj,
            }
        }));
    }

    handleAdd = () => {
        if (this.props.state.data.mutationSourceKodeLocator !== null) {
            const newRow = {
                [this.kodeKey]: null,
                [this.dtoKey]: {
                    [this.nameKey]: "",
                    [this.categoryKey]: "",
                },
                qty: 1,
                satuan: "",
                otherBarcode: "",
                saved: false,
            };

            this.props.onSetState((prevValue) => ({
                ...prevValue,
                data: {
                    ...prevValue.data,
                    [this.dataName]: [...prevValue.data[this.dataName], newRow],
                },
            }));
        } else {
            this.props.onSetState(prev=>({
                ...prev,
                alertVisible: true,
                warningMessage: "No Locator Detected"
            }));
        }
    };

    validateInputBarcode = async (index) =>{
       try {
        const request = {
            nameCategory: this.tabHadiah ? "GIFT" : "OTHER",
            barcode: this.props.state.data[this.dataName][index].otherBarcode,
            encryptBarcode: null,
            kodeCabang: this.props.state.data.mutationSourceKodeCabang.value,
            kodeLocator: this.props.state.data.mutationSourceKodeLocator.value,
            codeItem : this.props.state.data[this.dataName][index][this.kodeKey]?.value,
            trxType: this.props.mutasiKeluarTab ? "TRX_IN" : "TRX_OUT"
        }
        const response = await Api.create("NAGAMAS_TRANSACTION").findBarcodeKsuBrlHdhMutation(request);
        if(response.ok && response.data.data!==null){
            return 'Barcode Ditemukan'
        }
        return null
       } catch (error) {
        return null
       }
    }

    handleTriggerNoBarcodeDetected = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            noBarcodeDetected: !prevValue.noBarcodeDetected
        }))
    }

    handleSaveRow = async (index, isNeedValidate) => {
        if(isNeedValidate){
            const validateResult = await this.validateInputBarcode(index)
            if(validateResult===null){
                this.handleTriggerNoBarcodeDetected()
                return
            }
        }
        this.props.onSetState((prevValue) => {
            const newState = [...prevValue.data[this.dataName]];
            newState[index] = {
                ...newState[index],
                saved: !newState[index].saved,
            };

            if (!this.validDetail(newState[index])) {
                return {
                    ...prevValue,
                    alertVisible: !prevValue.alertVisible,
                    warningMessage: "Ada field data yang perlu diisi atau tidak sesuai kriteria isian. Mohon periksa kembali.",
                }
            }

            let duplicate = newState.filter(item => item.otherBarcode === newState[index].otherBarcode && item.saved === true);
            if (duplicate.length > 1) {
                return {
                    ...prevValue,
                    alertVisible: !prevValue.alertVisible,
                    warningMessage: "Barcode yang anda masukan sudah ada. Mohon periksa kembali.",
                }
            }

            return {
                ...prevValue,
                data: {
                    ...prevValue.data,
                    [this.dataName]: newState,
                },
            };
        });
    };

    validDetail = (obj) => {
        const column = [this.kodeKey, "otherBarcode"];
        for (const [key, data] of Object.entries(obj)) {
            if (column.includes(key) && R.or(R.isNil(data), !data, R.isEmpty(data))){
                return false;
            }
        }

        return true;
    }

    handleDeleteRow = (index) => {
        this.props.onSetState((prevValue) => ({
            ...prevValue,
            data: {
                ...prevValue.data,
                [this.dataName]: prevValue.data[this.dataName].filter((_, idx) => idx !== index),
            },
        }));
    };

    handleShowScanner = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            scannerVisible: !prevValue.scannerVisible,
        }));
    };

    handleScanQR = async (data) => {
        const request = {
            nameCategory: this.tabHadiah ? "GIFT" : "OTHER",
            encryptBarcode: data[0].rawValue,
            kodeCabang: this.props.state.data.mutationSourceKodeCabang.value,
            kodeLocator: this.props.state.data.mutationSourceKodeLocator.value,
            trxType: this.props.mutasiKeluarTab ? "TRX_IN" : "TRX_OUT"
        }
        const response = await Api.create("NAGAMAS_TRANSACTION").findBarcodeKsuBrlHdhMutation(request);
        if (response.ok && !R.isNil(response.data.data) && (!R.isEmpty(response.data.data))) {
            const data = response.data.data;
            if (this.props.state.data.mutationSourceKodeLocator.value === data.kodeLocator) {
                let obj;
                if (this.props.mutasiKeluarTab) {
                    const ddlValue = this.tabHadiah
                        ? this.props.state.kodeHadiahOptions.find((kh) =>
                            R.equals(kh.value, data.kodeItem)
                        )
                        :
                        this.props.state.kodeBarangLainOptions.find((kbl) =>
                            R.equals(kbl.value, data.kodeItem)
                        );
                    obj = {
                        otherBarcode: data.barcode,
                        qty: 1,
                        satuan: ddlValue.satuan,
                        saved: true,
                        scanned: false,
                        status: "NEW",
                        [this.kodeKey]: ddlValue ? {...ddlValue} : null,
                        [this.dtoKey]: ddlValue ? {
                            [this.categoryKey]: ddlValue.category,
                            [this.nameKey]: ddlValue.name
                        } : null
                    }
                    if(this.props.state.data[this.dataName].find(item => item.otherBarcode === obj.otherBarcode)){
                        this.props.onSetState((prevValue) => ({
                            ...prevValue,
                            isRejectAllAction: false,
                            anyByPassScanner: false,
                            alertVisible: true,
                            warningMessage: "Kode QR sudah ada di dalam daftar."
                        }))
                        return
                    }
                } else {
                    obj = this.props.state.data[this.dataName].filter((a, idx) => {
                        if (a.otherBarcode === data.barcode) {
                            a.checked = true;
                            a.scanned = true;
                            a.status = "RECEIVED";
                        }
                        return a
                    })
                }
                console.log("mutationGiftBarcodes",this.props.state.data?.[this.dataName]);
                const item = this.props.mutasiKeluarTab
                ? this.props.state.data?.[this.dataName] === undefined
                    ? [obj]
                    : [...this.props.state.data?.[this.dataName], obj]
                : obj;
                this.props.onSetState((prevValue) => ({
                    ...prevValue,
                    data: {
                        ...prevValue.data,
                        [this.dataName]: item,
                    },
                }));
            }

        }
        this.handleShowScanner();
    };

    addUnitButton = () => {
        if (this.props.mutasiKeluarTab) {
            if (this.props.state.data.mutationStatus === "NEW" || this.props.state.activityType === ACTIVITY_TYPE.CREATE) {
                return (
                    <>
                        <SimpleButton
                            icon={<i className="fa fa-plus margin-right-10px"></i>}
                            text="Tambah"
                            secondary={this.props.buttonType == "delete" || this.props.buttonType == "preview"}
                            disabled={this.props.buttonType == "delete" || this.props.buttonType == "preview"}
                            onClick={this.handleAdd}
                        />
                    </>
                )
            }
        }
    }

    addDetailButton = (val, rowIndex) => {
        if (this.props.mutasiKeluarTab) {
            if (this.props.state.data.mutationStatus === "NEW" || this.props.state.activityType === ACTIVITY_TYPE.CREATE) {
                return (
                    <>
                        <FlexView vAlignContent="center">
                            <Button className="btnAct" onClick={() => this.handleSaveRow(rowIndex, !val)} disabled={this.props.buttonType == "delete" || this.props.buttonType == "preview"}>
                                    <span
                                        style={{
                                            backgroundColor: "transparent",
                                            color: this.props.buttonType == "delete" || this.props.buttonType == "preview" ? "grey" : "red",
                                            fontSize: 20,
                                        }}
                                    >
                                      {!val ? <i className="fa fa-save"/> : <i className="fa fa-lw fa-pencil-alt"/>}
                                    </span>
                            </Button>
                            <Button className="btnAct margin-left-15px" onClick={() => this.handleDeleteRow(rowIndex)} disabled={this.props.buttonType == "delete" || this.props.buttonType == "preview"}>
                                <i
                                    className="fa fa-trash"
                                    style={{
                                        backgroundColor: "transparent",
                                        color: this.props.buttonType == "delete" || this.props.buttonType == "preview" ? "grey" : "red",
                                        fontSize: 20,
                                    }}
                                />
                            </Button>
                        </FlexView>
                    </>
                )
            } else {
                return  (
                    <>
                        <FlexView vAlignContent="center">
                            <input
                                id="input_checkbox_qr"
                                type="checkbox"
                                disabled
                                style={{width: "15px", height: "15px"}}
                                checked={this.props.state.data[this.dataName][rowIndex].checked}
                                onChange={() => this.handleChecked(rowIndex)}
                            />
                        </FlexView>
                    </>
                )
            }
        } else {
            if (this.props.state.data.mutationStatus === "PROCESSED" || this.props.state.activityType === ACTIVITY_TYPE.CREATE) {
                return  (
                    <>
                        <FlexView vAlignContent="center">
                            <input
                                id="input_checkbox_qr"
                                type="checkbox"
                                disabled
                                style={{width: "15px", height: "15px"}}
                                checked={this.props.state.data[this.dataName][rowIndex].checked}
                                onChange={() => this.handleChecked(rowIndex)}
                            />
                            <Button className="btnAct margin-left-15px" onClick={() => this.handleReject(rowIndex)} disabled={this.props.buttonType == "delete" || this.props.buttonType == "preview"}>
                                <span style={{ position: 'relative', fontSize: 20, display: 'inline-block' }}>
                                <i
                                  className="fas fa-hand-paper"
                                  style={{
                                    color:
                                      val === "REJECTED" || this.props.buttonType == "delete" || this.props.buttonType == "preview"
                                        ? "black"
                                        : "red",
                                  }}
                                />
                                <i
                                  className="fas fa-slash"
                                  style={{
                                    position: 'absolute',
                                    top: 2.5,
                                    left: 0,
                                    color:
                                      val === "REJECTED" || this.props.buttonType == "delete" || this.props.buttonType == "preview"
                                        ? "black"
                                        : "red",
                                  }}
                                />
                            </span>
                            </Button>
                        </FlexView>
                    </>
                )
            }
        }
    }

    handleChangePage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination:{
                ...prevValue.pagination,
                page: tableState.page + 1,
            }
        }));
    };

    handleRowsPerPage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination:{
                ...prevValue.pagination,
                page: 1,
                limit: tableState.rowsPerPage,
            }
        }));
    };

    render() {
        return (
            <>
                <FlexView vAlignContent="center" className="margin-bottom-10px" style={{gap: "10px"}}>
                    <h4>{this.tabHadiah ? "HADIAH" : "BARANG LAIN"}</h4>
                    {this.addUnitButton()}
                    <Button
                        type="button"
                        className="btn"
                        style={{borderRadius: "50%"}}
                        disabled={
                            this.props.mutasiKeluarTab ?
                                !(this.props.state.data.mutationStatus === "NEW" || this.props.state.activityType === ACTIVITY_TYPE.CREATE) || this.props.buttonType == "delete" || this.props.buttonType == "preview" :
                                !(this.props.state.data.mutationStatus === "PROCESSED" || this.props.state.activityType === ACTIVITY_TYPE.CREATE) || this.props.buttonType == "delete" || this.props.buttonType == "preview"
                        }
                        onClick={this.handleShowScanner}
                    >
            <span>
              <i className="fa fa-qrcode"></i>
            </span>
                    </Button>
                </FlexView>
                {this.state.noBarcodeDetected && (
                    <SimpleModal
                        title={"No Barcode Detected"}
                        styles={{width: "40%"}}
                        visible={this.state.noBarcodeDetected}
                        onClickClose={this.handleTriggerNoBarcodeDetected}
                        content={"No Barcode Detected"}
                    />
                )}
                <SimpleDataTable
                    key={`${this.props.state.data[this.dataName]?.length}-${this.state.pagination.page}`}
                    data={this.props.state.data[this.dataName]}
                    columns={this.tableColumns}
                    toCount={this.props.state.data[this.dataName]?.length}
                    rowsPerPage={this.state.pagination.limit}
                    page={this.state.pagination.page - 1}
                    options={{...defaultTableChange(this.handleChangePage, this.handleRowsPerPage), serverSide: false}}
                />
                {this.state.scannerVisible && (
                    <SimpleModal
                        title={"Scan QR Here"}
                        styles={{width: "40%"}}
                        visible={this.state.scannerVisible}
                        onClickClose={this.handleShowScanner}
                        content={
                            <Scanner
                                onScan={this.handleScanQR}
                                constraints={{
                                    height: {ideal: 720},
                                    video: {
                                        facingMode: { exact: "environment" },
                                        height: { ideal: 720 }
                                    },
                                }}
                            />
                        }
                    />
                )}
            </>
        );
    }
}

export default MutasiDetailQrTab;
